<template>
  <v-content fluid grid-list-lg class="allNotesCard__container">
    <v-layout row wrap style="position: relative;">
        <FakeNote v-show="!fullNotesTopEnd"/>
        <FakeNote v-show="!fullNotesTopEnd"/>
        <FakeNote v-show="!fullNotesTopEnd"/>
        <FakeNote v-show="!fullNotesTopEnd"/>
        <FakeNote v-show="!fullNotesTopEnd"/>
        <FakeNote v-show="!fullNotesTopEnd"/>
        <FakeNote v-show="loadingPagination && !fullNotesTopEnd" ref="topLoader"/>
        <template v-for="(note, i) in clientNotes">
          <Note :noteItem="note" :todayDate="todayDate" :key="i + Math.random()" :ref="note.date" />
        </template>
        <FakeNote v-show="loadingPagination && !fullNotesBottomEnd" ref="bottomLoader" />
        <FakeNote v-show="!fullNotesBottomEnd"/>
        <FakeNote v-show="!fullNotesBottomEnd"/>
        <FakeNote v-show="!fullNotesBottomEnd"/>
        <FakeNote v-show="!fullNotesBottomEnd"/>
        <FakeNote v-show="!fullNotesBottomEnd"/>
        <FakeNote v-show="!fullNotesBottomEnd"/>
      <v-slide-y-transition>
        <div v-show="notFullNotes" >
          <v-flex pa4 text-center>
            <h2>Вы не добавили ни одной заметки</h2>
            <p>Кликните на календаре и создайте заметку</p>
          </v-flex>
        </div>
      </v-slide-y-transition>
      
    </v-layout>
  </v-content>
</template>
<script>

import { debounce } from 'lodash';
import Note from './Note';
import FakeNote from './NoteFake'
import { mapState } from 'vuex';
import noteMethods from '../../mixins/note'
import filledNotes from '../../mixins/filledNotes'

export default {
  name: 'Notes',
  props: {},
  components: {
    Note,
    FakeNote
  },
  mixins: [noteMethods,filledNotes],
  data() {
    return {
      notFullNotes: false,
      // =====
      maxDateNotesHashMap: [],
      minDateNotesHashMap: [],
      minDateNotes: [],
      maxDateNotes: [],
      clientNotes: [],
      allNotesHash: [],
      inViewNote: null,
      // === ПАГИНАЦИЯ ===
      fullNotesTopEnd: false,
      fullNotesBottomEnd: false,
      nextPageHash: [],
      prevPageHash: [],
      loadingPagination: true,
      topNotesEmpty: false,
      bottomNotesEmpty: false,
      minDatesFilledNext: null,
      maxDatesFilledNext: null,
      // =======SCROLLS
      scrollTopObserver: null,
      scrollDownObserver: null,
      currObserver: null,
      scrollToNoteTarget: null,
      // ----
      upCount: null,
      topNote: '',
      bottomNote: '',
      middleNote: '',
      domScrollItemsAmount: 3, // Количество скролящихся элементов
      minDateNextPage: null,
      minDateUsedElems: 0,
      maxDateNextPage: null,
      maxDateUsedElems: 0,
      requestsReady: false,
      todayDate: moment(new Date()).format('YYYY-MM-DD'),
      loadingReady: false,
      scrollOnce: false,
      showingFullNotes: false,
      calendarSyncStatus: true,
      // Хранилище заполненных заметок
      filledNotesStorage: {}
    };
  },
  methods: {
    scrolledToTop() {
      if(this.showingFullNotes) {
        this.getNextForFullNotes()
      } else {
        this.init(this.topNote, true)
      }
    },
    scrolledToDown() {
      if(this.showingFullNotes) {
        this.getPrevForFullNotes()
      } else {
        this.init(this.bottomNote, false)
      }
    },  
    disableScroll() {
      let _parent = document.getElementById('notesList')
      _parent.style = 'overflow-y:hidden;'
    },  
    enableScroll() {
      let _parent = document.getElementById('notesList')
      _parent.style = 'overflow-y:scroll;'
    },
    scrollToNote(date, withoutFakes=false) {
      this.scrollToNoteTarget = this.$refs[date][0].$el
      this.currObserver = new IntersectionObserver((entries) => {
          let [entry] = entries;
          if (entry.isIntersecting) {
            this.observing(true) // Включаем наблюдение за лоадерами
          }
      });
      this.currObserver.observe(this.scrollToNoteTarget)
      // this.scrollToNoteTarget.scrollIntoView({block: 'center'})
      this.scrollToNoteTarget.scrollIntoView({block: 'start'})
    }
  },
  computed: {},
  created() {
    this.init(this.todayDate, 'today');
  },
  destroyed() {
    this.$bus.$off('datePickerInit');
    this.$bus.$off('goToToday');
    this.$bus.$off('scrollToTop');
    this.$bus.$off('scrollToDown');
    this.$bus.$off('selectDateOnCalendar')
    this.$bus.$off('goToSearchedNote')
    this.$bus.$off('calendarSync')
    this.$bus.$off('toggleEditorTools')
    this.$bus.$off('inViewCurrentNote')
  }
        
};
</script>
<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/apps/bpm/notes/components/notes/Notes.vue